export const RingsActionTypes = {
  SET_ALL_RINGS: "SET_ALL_RINGS",
  SET_LIKED_RING_URLS: "SET_LIKED_RING_URLS",
  SET_LIKED_RINGS: "SET_LIKED_RINGS",
  ADD_LIKED_RING: "ADD_LIKED_RING",
  SET_LAST_FETCHED_RING: "SET_LAST_FETCHED_RING",
  ADD_LIKED_RING_URL: "ADD_LIKED_RING_URL",
};
